




















import { defineComponent, PropType, Ref, ref } from '@vue/composition-api';
import cButton                                 from '@/components/form/button/button.component.vue';
import cIconArrowDown                          from '@/components/icons/icon-arrow-down.component.vue';

export default defineComponent({
  name: 'cNotificationError',
  components: { cIconArrowDown, cButton },
  props: {
    message: {
      type: String,
      required: true,
    },
    stacktrace: {
      type: Array as PropType<string[]>,
      default: null,
    },
  },
  setup() {
    const showDetails: Ref<boolean> = ref(false);

    return {
      showDetails,
    };
  },
});

